import type { Post } from '@entities/post'
import { CustomTag } from '@shared/ui/custom-tag/custom-tag'
import { Button, Flex, Modal, Row } from 'antd'
import { MessageView } from '../message-view/message-view'

interface AddPostModalProps {
    open: boolean
    post?: Post
    onClose: () => void
    onEditModalOpen?: (post: Post) => void
}

export const PreviewPostModal = ({ open, onClose, post, onEditModalOpen }: AddPostModalProps) => {
    const handleEditModalOpen = () => {
        if (onEditModalOpen && post) {
            onEditModalOpen(post)
            onClose()
        }
    }
    if (!post) {
        return null
    }

    return (
        <Modal
            open={open}
            centered
            onCancel={onClose}
            footer={[
                <Button key="back" onClick={onClose}>
                    Отмена
                </Button>,
                onEditModalOpen && (
                    <Button
                        key="edit"
                        onClick={handleEditModalOpen}
                        disabled={post.isAdvertising && post.state === 'planned'}
                    >
                        Редактировать
                    </Button>
                ),
                <Button key="submit" type="primary" onClick={onClose}>
                    Ок
                </Button>
            ]}
            title="Превью поста"
        >
            {post.postType && (
                <Row gutter={16} style={{ marginBottom: 20 }}>
                    <CustomTag color={post.postType?.color}>{post.postType.name}</CustomTag>
                </Row>
            )}
            <Flex gap="middle" vertical>
                {post.messages.map((item) => (
                    <MessageView message={item} key={item.id} />
                ))}
            </Flex>
        </Modal>
    )
}
